// src/pages/admin/jobDetail/ItemList.jsx — bin/item row list used by JobDetailPage's
// delivered/picked-up/emptied sections
import { getQty } from "./helpers";

export default function ItemList({ items, emptyText }) {
  if (!items.length) {
    return <p className="text-sm text-gray-500">{emptyText}</p>;
  }

  return (
    <div className="space-y-2">
      {items.map((item, idx) => (
        <div
          key={`${item.binId || item.binName || "item"}-${idx}`}
          className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2"
        >
          <div className="min-w-0">
            <div className="font-medium text-gray-900">
              {item.binName || item.name || item.size || "Bin"}
            </div>
            <div className="text-xs text-gray-500">
              {[item.categoryName, item.binId ? `Bin ID: ${item.binId}` : ""]
                .filter(Boolean)
                .join(" • ")}
            </div>
          </div>
          <div className="shrink-0 rounded-full bg-white border border-gray-200 px-3 py-1 text-sm font-semibold text-gray-800">
            {getQty(item)}
          </div>
        </div>
      ))}
    </div>
  );
}
